/**
 * Format a time delta in seconds to a human-readable string.
 * Negative = before ICP test, positive = after ICP test.
 * Examples: "30 min before", "2 hours after", "1 day before"
 */
export function formatTimeDelta(deltaSeconds: number): string {
  const abs = Math.abs(deltaSeconds);
  const direction = deltaSeconds < 0 ? 'before' : 'after';

  if (abs < 60) {
    return deltaSeconds === 0 ? 'same time' : `just ${direction}`;
  }
  if (abs < 3600) {
    const mins = Math.round(abs / 60);
    return `${mins} min ${direction}`;
  }
  if (abs < 86400) {
    const hours = Math.round(abs / 3600);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ${direction}`;
  }
  const days = Math.round(abs / 86400);
  return `${days} ${days === 1 ? 'day' : 'days'} ${direction}`;
}
